import React, { Component } from 'react';

import { Col, Row, UncontrolledCollapse, Button, Card, CardBody, CardHeader } from 'reactstrap';
import styled from 'styled-components';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

class ViewSwitcher extends Component {
  constructor(props) {
    super(props);
    this.state = {
      views: props.views,
      selectedKey: props.selectedKey
    };
  }

  componentWillReceiveProps(nextProps) {
    if (this.state.views !== nextProps.views) {
      // if (this.state.selectedKey !== nextProps.selectedKey) {
      //   this.setState({ views: nextProps.views, selectedKey: nextProps.selectedKey });
      // } else {
      if (nextProps.views.filter(view => this.state.selectedKey === view.key).length > 0) {
        this.setState({ views: nextProps.views });
      } else {
        this.setState({ views: nextProps.views, selectedKey: nextProps.views[0].key });
      }
      // }
      // } else {
      // if (this.state.selectedKey !== nextProps.selectedKey) {
      //   this.setState({ selectedKey: nextProps.selectedKey });
      // }
    }
  }

  render() {
    const views = this.state.views;
    const selectedKey = this.state.selectedKey;
    const selectedView = views.filter(view => view.key === selectedKey)[0];
    const options = views.map(view => (
      <MenuItem key={view.key} value={view.key}>{view.name}</MenuItem>
    ));
    return (
      <div
        className={this.props.className}
        style={{ display: 'flex', flexDirection: 'column', ...this.props.style }}
      >
        <div style={{ flex: '0 0' }}>
          <Select
            value={selectedKey}
            onChange={e => this.setState({ selectedKey: e.target.value })}
            displayEmpty
            name="age"
            style={{ width: '100%', flexDirection: 'column', marginTop: '0.5em', marginBottom: '0.5em', fontSize: '2em' }}
          >
            {options}
          </Select>
        </div>
        <div style={{ flex: '0 1 100%', flexDirection: 'column', height: '100%' }}>
          {selectedView.content}
        </div>
      </div>
    );
  }
}

export default ViewSwitcher;



// WEBPACK FOOTER //
// ./src/componentes/ViewSwitcher.js